export const hazardTranslationKeys = {
    GH201: 'hazard.explosive',
    GH202: 'hazard.flammable',
    GH203: 'hazard.inflammable',
    GH204: 'hazard.gasUnderPressure',
    GH205: 'hazard.corrosive',
    GH206: 'hazard.toxicity',
    GH207: 'hazard.healthHazard',
    GH208: 'hazard.seriousHealthHazard',
    GH209: 'hazard.dangerForEnvironment',
};
